import { documentRepo } from "@/repositories/documentRepo";
import { useObservable } from "@repo/ui/components/Base/hooks/useObservable";
import { map } from "rxjs";
import { teamFilter, type TeamIdOrOrg } from "./common";

export const useGetDocument = (tenantId: string, documentId: string) => {
  return useObservable(
    () => documentRepo.get(tenantId, documentId),
    [tenantId, documentId]
  );
};

export const useDocumentList = (tenantId: string, teamId: TeamIdOrOrg) => {
  return useObservable(
    () => documentRepo.list(tenantId).pipe(map(teamFilter(teamId))),
    [tenantId, teamId]
  );
};

export const useOrdinanceList = (tenantId: string, teamId: TeamIdOrOrg) => {
  return useObservable(
    () =>
      documentRepo
        .list(tenantId)
        .pipe(
          map((list) =>
            list.filter(
              (item) =>
                item.uploadType === "ordinances" &&
                !item.confidential &&
                (teamId == null || item.teamId === teamId)
            )
          )
        ),
    [tenantId, teamId]
  );
};
